import objectUtils from '../utils/object-utils'

export default class DriverInfo {
  constructor (options = {}) {
    this.model = 'DriverInfo'
    this.id = objectUtils.get(options, 'id', null)
    this.user_id = objectUtils.get(options, 'user_id', null)

    this.prefs = objectUtils.get(options, 'prefs', {})
    this.settings = objectUtils.get(options, 'settings', {})
    this.notes = objectUtils.get(options, 'notes', null)
    this.status = objectUtils.get(options, 'status', null)

    this.available_times = (options.available_times && !options.available_times.isEmpty)
      ? options.available_times
      : loadDefaultAvailableTimes()

    this.created_at = objectUtils.get(options, 'created_at', null)
    this.updated_at = objectUtils.get(options, 'updated_at', null)
  }
}

function loadDefaultAvailableTimes () {
  return {
    mon: { start: '00:00', end: '00:00' },
    tue: { start: '00:00', end: '00:00' },
    wed: { start: '00:00', end: '00:00' },
    thu: { start: '00:00', end: '00:00' },
    fri: { start: '00:00', end: '00:00' },
    sat: { start: '00:00', end: '00:00' },
    sun: { start: '00:00', end: '00:00' }
  }
}
